// addEventListener("DOMContentLoaded", (event) => {
// Icon With Text Slider
const iconTextCarousel = document.querySelector(
  ".block__icon-with-text-slider"
);
if (iconTextCarousel) {
  var swiper = new Swiper(iconTextCarousel, {
    spaceBetween: 32,
    centeredSlides: true,
    speed: 3500,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
}

// Logo Slider
const logoCarousel = document.querySelector(".block__logo-slider");
if (logoCarousel) {
  var swiper = new Swiper(logoCarousel, {
    spaceBetween: 12,
    centeredSlides: true,
    speed: 2500,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
}

// Collection Slider
const collectionCarousel = document.querySelector(".block__collection-slider");
var mobile = window.matchMedia("(min-width: 749px)");
if (mobile.matches) {
  if (collectionCarousel) {
    var swiper = new Swiper(collectionCarousel, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      navigation: {
        nextEl: ".collection-slider-arrow-next",
        prevEl: ".collection-slider-arrow-prev",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1439: {
          slidesPerView: 4,
        },
      },
    });
  }
}

// Product Info Slider
const productCarousel = document.querySelector(".product-how-use-collection-slider");
if (productCarousel) {
  var swiper = new Swiper(productCarousel, {
    slidesPerView: 1.4,
    spaceBetween: 10,
    loop: true,
    allowTouchMove: true,
    disableOnInteraction: true,
    navigation: {
      nextEl: ".product-how-use-collection-next",
      prevEl: ".product-how-use-collection-prev",
    },
    breakpoints: {
      390: {
        spaceBetween: 10,
        allowTouchMove: true,
        slidesPerView: 1.4,
      },
      750: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      992: {
        spaceBetween: 0,
        slidesPerView: 1,
      },
    },
  });
}

// New Article Product Slider
const newArticleProduct = document.querySelector(".block__new-article-product-slider");
var mobile = window.matchMedia("(min-width: 749px)");
if (mobile.matches) {
if (newArticleProduct) {
  var swiper = new Swiper(newArticleProduct, {
    slidesPerView: 3,
    spaceBetween: 16,
    loop: false,
    allowTouchMove: true,
    disableOnInteraction: true,
    navigation: {
      nextEl: ".new-article-arrow-next",
      prevEl: ".new-article-arrow-prev",
    },
    breakpoints: {
      370: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      750: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      992: {
        spaceBetween: 10,
        slidesPerView: 3,
      },
      1200: {
        spaceBetween: 16,
        slidesPerView: 3,
      },
    },
  });
}
}

// Product Info Slider
const relatedArticle = document.querySelector(".block__related-article-slide");
if (relatedArticle) {
  var swiper = new Swiper(relatedArticle, {
    slidesPerView: 1.2,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    allowTouchMove: true,
    disableOnInteraction: true,
    navigation: {
      nextEl: ".related-article-arrow-next",
      prevEl: ".related-article-arrow-prev",
    },
    breakpoints: {
      370: {
        spaceBetween: 10,
        allowTouchMove: true,
        slidesPerView: 1.1,
        centeredSlides: true
      },
      750: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      992: {
        spaceBetween: 34,
        slidesPerView: 3,
      },
    },
  });
}

const productsCarousel = document.querySelectorAll(".product-tab-slider");
var mobile = window.matchMedia("(min-width: 749px)");
if (mobile.matches) {
  productsCarousel.forEach((carousel) => {
    var swiper = new Swiper(carousel, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      navigation: {
        nextEl: carousel
          .closest(".product-tab-slider-block")
          .querySelector(".product-swiper-button-next"),
        prevEl: carousel
          .closest(".product-tab-slider-block")
          .querySelector(".product-swiper-button-prev"),
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        992: {
          spaceBetween: 10,
          slidesPerView: 3,
        },
        1439: {
          slidesPerView: 4,
        },
      },
    });
  });
}

let relatedObserver = new MutationObserver(checkForRelatedElement);
const relatedConfig = { childList: true, subtree: true };
relatedObserver.observe(document.body, relatedConfig);
function checkForRelatedElement() {
  let element = document.querySelector(".block__related-product-grid");
  if (element) {
    relatedObserver.disconnect(); // Stop the MutationObserver
    relatedProductsSlider();
  }
}
function relatedProductsSlider() {
  const relatedProductsCarousel = document.querySelector(".block__related-product-grid");
  var mobile = window.matchMedia("(min-width: 749px)");
  if (mobile.matches) {
      var swiper = new Swiper(relatedProductsCarousel, {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        allowTouchMove: false,
        disableOnInteraction: true,
        navigation: {
          nextEl: relatedProductsCarousel.closest(".block__related-product-main").querySelector(".related-product-arrow-next"),
          prevEl: relatedProductsCarousel.closest(".block__related-product-main").querySelector(".related-product-arrow-prev"),
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
          992: {
            spaceBetween: 10,
            slidesPerView: 3,
          },
          1439: {
            slidesPerView: 4,
          },
        },
    });
  }

  if (typeof yotpoWidgetsContainer !== "undefined") {
    yotpoWidgetsContainer.initWidgets(false);
  }
}

// Product Slider tabify
var productsTabItems = document.querySelectorAll(
  "ul.block__product-tab-nav li"
);
productsTabItems.forEach(function (tab) {
  tab.addEventListener("click", function () {
    productsTabItems.forEach(function (item) {
      console.log(item);
      item.classList.remove("current");
    });
    var tab_id = this.getAttribute("data-tab");
    var tabContents = document.querySelectorAll(".product-tab-slider-block");
    tabContents.forEach(function (content) {
      content.classList.remove("current");
    });
    this.classList.add("current");
    document.getElementById(tab_id).classList.add("current");
  });
});

const trendingCarousel = document.querySelectorAll(".trending-product-tab-slider");
var mobile = window.matchMedia("(min-width: 749px)");
if (mobile.matches) {
  trendingCarousel.forEach((carousel) => {
    var swiper = new Swiper(carousel, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      navigation: {
        nextEl: carousel
          .closest(".trending-product-tab-slider-block")
          .querySelector(".trending-product-swiper-button-next"),
        prevEl: carousel
          .closest(".trending-product-tab-slider-block")
          .querySelector(".trending-product-swiper-button-prev"),
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1360: {
          slidesPerView: 4,
        },
      },
    });
  });
}

// Trending Product Slider Tabify
var tabItems = document.querySelectorAll(
  "ul.block__trending-product-tab-nav li"
);
tabItems.forEach(function (tab) {
  tab.addEventListener("click", function () {
    var tab_id = this.getAttribute("data-tab");
    tabItems.forEach(function (item) {
      item.classList.remove("current");
    });
    var tabContents = document.querySelectorAll(
      ".trending-product-tab-slider-block"
    );
    tabContents.forEach(function (content) {
      content.classList.remove("current");
    });
    this.classList.add("current");
    document.getElementById(tab_id).classList.add("current");
  });
});


// Video Product Slider
const videoProductCarousel = document.querySelector(
  ".block__video-with-product-slider"
);
if (videoProductCarousel) {
  var swiper = new Swiper(videoProductCarousel, {
    loop: true,
    allowTouchMove: true,
    disableOnInteraction: true,
    navigation: {
      prevEl: ".video-with-product-swiper-button-next",
      nextEl: ".video-with-product-swiper-button-prev",
    },
    centeredSlides: true,
    slidesPerView: "auto",
    spaceBetween: 10,
    on: {
      transitionStart: function () {
        var videos = videoProductCarousel.querySelectorAll(
          ".block__video-with-product-video video"
        );
        videos.forEach(function (video) {
          video.pause();
          video.controls = false;
        });
      },
      transitionEnd: function () {
        var activeSlide = videoProductCarousel.querySelector(
          ".swiper-slide-active"
        );
        var activeSlideVideo = activeSlide.querySelector(
          ".block__video-with-product-video video"
        );
        if (activeSlideVideo) {
          activeSlideVideo.play();
          activeSlideVideo.controls = true;
        }
      },
    },
  });
}

// const jQuerysample_atc_submit_event = async function (jQueryform_data) {
//   const jQuerysample_addtocart_result = await fetch("/cart/add.json", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(jQueryform_data),
//   });
//   const jQueryatc_success_result = await jQuerysample_addtocart_result.json();
//   if (jQueryatc_success_result.items) {
//     if (
//       document.querySelector("cart-drawer") &&
//       document.querySelector("cart-drawer").classList.contains("is-empty")
//     )
//       document.querySelector("cart-drawer").classList.remove("is-empty");
//     const quickAddModal = document.querySelector("quick-add-modal");
//     if (quickAddModal) {
//       document.body.addEventListener(
//         "modalClosed",
//         () => {
//           setTimeout(() => {
//             document
//               .querySelector("cart-drawer")
//               .renderContents(jQueryatc_success_result);
//           });
//         },
//         { once: true }
//       );
//       quickAddModal.hide(true);
//     } else {
//       document.querySelector("cart-drawer").renderContents(jQueryatc_success_result);
//     }
//   } else {
//     console.error(jQueryatc_success_result);
//   }
// };
// jQuery(document).on("click", ".block__video-with-product-btn button", function (e) {
//   e.preventDefault();
//   var varID = jQuery(this).parents(".block__video-with-product-btn").find('[name="id"]').val();

//   let sample_product_atc_array = [];
//   sample_product_atc_array.push({
//     id: varID,
//     quantity: 1,
//   });
//   let sample_product_atc_formData = {
//     items: sample_product_atc_array,
//     sections_url: window.location.pathname,
//     sections: document
//       .querySelector("cart-drawer")
//       .getSectionsToRender()
//       .map((section) => section.id),
//   };
//   jQuerysample_atc_submit_event(sample_product_atc_formData);
// });

// Footer Section
jQuery(document).ready(function () {
  if (jQuery(window).width() < 768) {
    jQuery(".block__footer-menu-block ul").hide();
    jQuery(".block__footer-menu-title").unbind().click(function () {
        jQuery(".block__footer-menu-title").not(jQuery(this)).removeClass("active");
        jQuery(".block__footer-menu-block ul").not(jQuery(this).siblings(".block__footer-menu-block ul")).slideUp();
        jQuery(this).siblings(".block__footer-menu-block ul").slideToggle();
        jQuery(this).toggleClass("active");
      });
  }
});
if (jQuery(window).width() < 768) {
  jQuery(".block__footer-menu-block ul").hide();
  jQuery(".block__footer-menu-title").unbind().click(function () {
    jQuery(".block__footer-menu-title").not(jQuery(this)).removeClass("active");
    jQuery(".block__footer-menu-block ul").not(jQuery(this).siblings(".block__footer-menu-block ul")).slideUp();
    jQuery(this).siblings(".block__footer-menu-block ul").slideToggle();
    jQuery(this).toggleClass("active");
  });
} else {
  jQuery(".block__footer-menu-block ul").show();
}

// Header Drawer
var footerMenuTitles = document.querySelectorAll(".block__menu-drawer-menu-title");

footerMenuTitles.forEach(function (title) {
  title.nextElementSibling.style.display = "none";

  title.addEventListener("click", function () {
    var submenu = title.nextElementSibling;
    submenu.style.display = submenu.style.display === "none" ? "block" : "none";
    title.classList.toggle("active");
  });
});

// Faq Mobile Dro Down
jQuery(document).on("click", ".block__faq-mobile-dropdown-head", function () {
  jQuery(this).parents(".faq_type_list").find(".block__faq-mobile-dropdown").slideToggle();
  jQuery(this).toggleClass("active");
});
jQuery(document).on("click", ".block__faq-mobile-dropdown", function () {
  jQuery(this).parents(".faq_type_list").find(".block__faq-mobile-dropdown-head").toggleClass("active");
  jQuery(this).slideToggle("active");
});

// Faq Section
jQuery(document).on("click", ".block__faq-tabs_title", function () {
  if (jQuery(this).parents(".block__faq-slide").hasClass("block__faq-change-icon")) {
    jQuery(this).parent().find(".block__faq-panel").slideUp();
    jQuery(this).parents(".block__faq-slide").removeClass("block__faq-change-icon");
  } else {
    jQuery(this).parents(".block__faq-slider-main-containar").find(".block__faq-panel").slideUp();
    jQuery(this).parent().find(".block__faq-panel").slideDown();
    jQuery(this).parents(".block__faq-slider-main-containar").find(".block__faq-slide").removeClass("block__faq-change-icon");
    jQuery(this).parents(".block__faq-slide").addClass("block__faq-change-icon");
  }
});
jQuery(document).on("click", ".js_faq_heading", function () {
  var data_id = jQuery(this).attr("href");
  jQuery(".js_faq_heading").removeClass("active");
  jQuery(this).addClass("active");
  var target_offset = jQuery(".block__faq-list-block" + data_id).offset().top - 150;
  jQuery("html, body").animate({ scrollTop: target_offset }, 1000);
});

if (jQuery(".js_faq_heading").length) {
  var lastId,
    menuItems = jQuery(".block__faq-list-block"),
    scrollItems = menuItems.map(function () {
      var item = jQuery(this);
      if (item.length) {
        return item;
      }
    });

  jQuery(window).scroll(function () {
    var fromTop = jQuery(this).scrollTop() + jQuery(".header").height() + 250;
    var cur = scrollItems.map(function () {
      if (jQuery(this).offset().top < fromTop) return this;
    });

    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
      lastId = id;
      if (cur != undefined) {
        var data_id = cur[0].id;
        jQuery(".js_faq_heading").removeClass("active");
        jQuery(".js_faq_heading[href='" + "#" + data_id + "']").addClass("active");
      }
    }
    var active_id = jQuery(".js_faq_heading.active").attr("href");
    console.log("active_id", active_id);
    var currentUrl = window.location.href;
    var baseUrl = currentUrl.split("#")[0]; // Get the base URL without the fragment
    var newUrl = baseUrl + active_id;
    history.replaceState(null, null, newUrl);
  });
}

jQuery(document).ready(function () {
   jQuery('.subscribe_product.subscribe_product-multiple').click(function(){
     //$(this).closest('.container').addClass('hide'); 
    jQuery('#bwpFrame').addClass('hide');
    jQuery('.seprator-line').addClass('hide');
  })
    jQuery('.subscribe_product.subscribe_product-one').click(function(){
     //$(this).closest('.container').addClass('hide'); 
    jQuery('#bwpFrame').removeClass('hide');
    jQuery('.seprator-line').removeClass('hide');
  }) 

  // Check if the screen width is less than a certain threshold (e.g., 768 pixels for typical mobile devices)
  if (jQuery(window).width() < 991) {
    jQuery(document).on("click", ".block__blog-breadcrumb-category p", function () {
      jQuery(this)
        .parents(".block__blog-breadcrumb-category")
        .find("ul")
        .slideToggle();
      jQuery(this).toggleClass("active");
    });
  }

  // Main order accordian
  jQuery(".block_account-order-list .block__account-order-box:nth-child(1) .block__account-order-header").addClass("active");
  jQuery(".block_account-order-list .block__account-order-box:nth-child(1) .block__account-order-content").slideDown();
  jQuery(".block__account-order-header").on("click", function () {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).siblings(".block__account-order-content").slideUp();
      jQuery(this).removeClass("active");
    } else {
      jQuery(".block__account-order-content").slideUp();
      jQuery(".block__account-order-header").removeClass("active");
      jQuery(this).siblings(".block__account-order-content").slideToggle();
      jQuery(this).toggleClass("active");
    }
  });

  // Product Incrediant Section Drop-Down
  jQuery(".block__product-ingredients-caption-head").click(function () {
    jQuery(this).toggleClass("active");
    jQuery(".block__product-ingredients-caption").slideToggle();
  });
  
  // Product Info Tab
  jQuery("ul.block__product-tab-info-nav li").click(function () {
    var tab_id = jQuery(this).attr("data-id");
    console.log("tab_id", tab_id);
    jQuery("ul.block__product-tab-info-nav li").removeClass("current");
    jQuery(".product-tab-info-content").removeClass("current");

    jQuery(this).addClass("current");
    jQuery("#" + tab_id).addClass("current");
  });

  // on subscription change to value change product card
  jQuery(".block_product-subscribe_opt input[type=radio]").click(function () {
    var getPrice = jQuery(this).parents(".block_product-subscribe_opt").find(".block_product-grid_subscribe-price").attr("data-price");
    jQuery(this).parents(".card__information-hover-info").find(".quick-add__submit .button-price").text(getPrice);
  });

  // on subscription change to value change product card
  jQuery(document).on('change', '.block_subscription-options input[type=radio]', function() {
    if (jQuery(this).is(":checked") && jQuery(this).val() === "subscribe") {
      var getInputVal = jQuery(this).parents(".block_product-subscribe_opt").find(".block_product-subscribe_drawer select").find(":selected").attr("value");
      jQuery(this).parents(".card__information-hover-info").find(".block__product-card-subscription-val").prop("value", getInputVal);
      jQuery(this).parents(".card__information-hover-info").find(".quick-add__submit").attr('data-product-subscription', getInputVal);
      jQuery(this).parents(".block_product-subscribe_opt").find(".block_product-subscribe_drawer select").change(function () {
          var getInputVal = jQuery(this).find(":selected").attr("value");
          console.log("getInputVal",getInputVal)
          jQuery(this).parents(".card__information-hover-info").find(".block__product-card-subscription-val").prop("value", getInputVal);
          jQuery(this).parents(".card__information-hover-info").find(".quick-add__submit").attr('data-product-subscription', getInputVal);
        });
    } else {
      var getInputVal = jQuery(this).attr("value");
      jQuery(this).parents(".card__information-hover-info").find(".block__product-card-subscription-val").prop("value", getInputVal);
      jQuery(this).parents(".card__information-hover-info").find(".quick-add__submit").attr('data-product-subscription', getInputVal);
    }
  });

});
// customer-contact-form
//  input tel
function validatePhoneInput(input) {
  input.value = input.value.replace(/\D/g, "");

  if (input.value.length > 10) {
    input.value = input.value.slice(0, 10);
  }
}

//  input text  name filed
const ContactForm = document.getElementById("ContactForm-name");
if (ContactForm) {
  ContactForm.addEventListener("input", function (event) {
    var input = event.target;
    var pattern = /^[A-Za-z\s]+jQuery/;
    
    if (!pattern.test(input.value)) {
      input.setCustomValidity("Please enter Alphabets Only");
    } else {
      input.setCustomValidity("");
    }
  });
}

//  video play and push js
document.querySelectorAll(".video-icon").forEach(function (icon) {
  icon.addEventListener("click", function () {
    var video = icon.parentElement.querySelector(".block__video-video");
    var playIcon = icon.parentElement.querySelector(".video-icon.play");
    var pauseIcon = icon.parentElement.querySelector(".video-icon.pause");

    if (video.paused) {
      video.play();
      playIcon.style.display = "none";
      pauseIcon.style.display = "flex";
    } else {
      video.pause();
      playIcon.style.display = "flex";
      pauseIcon.style.display = "none";
    }
  });
});

// Image scrolling in landing page
let observerLanding = new MutationObserver(checkForElementLanding);
const configLanding = { childList: true, subtree: true };
observerLanding.observe(document.body, configLanding);
function checkForElementLanding() {
  let element = document.getElementById('block__landing-results-slider');
  if (element) {
    observerLanding.disconnect(); // Stop the MutationObserver
    LandingImgAfterBefore();
  }
} 

function LandingImgAfterBefore (){
const slider = document.getElementById("block__landing-results-slider");
slider.addEventListener("input", function () {
const frontImage = document.querySelector(".front-img");
frontImage.style.clipPath = `polygon(0 0, ${this.value}% 0, ${this.value}% 100%, 0% 100%)`;
$(".block__research-results-img-button").css("left", this.value + "%");
});
}

// Image scrolling in PDP page

// let observerPdp = new MutationObserver(checkForElement);
// const configPdp = { childList: true, subtree: true };
// observerPdp.observe(document.body, configPdp);
// function checkForElement() {
//   let element = document.getElementById('result_slider');
//   if (element) {
//     observerPdp.disconnect(); // Stop the MutationObserver
//     pgpImgAfterBefore();
//   }
// } 

// function pgpImgAfterBefore (){
//   const slider_img = document.getElementById("result_slider"); // No # in getElementById
//   slider_img.addEventListener("input", function (event) {
//       const frontImagePDP = document.querySelector(".block__research-results-after-img");
//       frontImagePDP.style.clipPath = `polygon(0 0, ${event.target.value}% 0, ${event.target.value}% 100%, 0% 100%)`;
//       $(".block__research-results-img-button").css("left", "calc(" + event.target.value + "% - 18px)");
//   });
// }

if ($(".block__research-results-img").length) {
  function initComparisons() {
    var x, i;
    x = document.getElementsByClassName("block__research-results-after-img");
    let y = document.querySelector(".block__research-results-before-img");
    for (i = 0; i < x.length; i++) {
      compareImages(x[i]);
    }
    function compareImages(img) {
      var slider, img, clicked = 0, w, h;
      w = img.offsetWidth;
      h = img.offsetHeight;
      $(window).resize(function () {
        w = y.offsetWidth;
        h = y.offsetHeight;
      })
      img.style.width = (w / 2) + "px";
      var slider = document.querySelector('.block__research-results-img-button');
      slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
      slider.addEventListener("mousedown", slideReady);
      window.addEventListener("mouseup", slideFinish);
      slider.addEventListener("touchstart", slideReady);
      window.addEventListener("touchend", slideFinish);
      function slideReady(e) {
        e.preventDefault();
        clicked = 1;
        window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
      }
      function slideFinish() {
        clicked = 0;
      }
      function slideMove(e) {
        var pos;
        if (clicked == 0) return false;
        pos = getCursorPos(e)
        if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        slide(pos);
      }
      function getCursorPos(e) {
        var a, x = 0;
        e = (e.changedTouches) ? e.changedTouches[0] : e;
        a = img.getBoundingClientRect();
        x = e.pageX - a.left;
        x = x - window.pageXOffset;
        return x;
      }
      function slide(x) {
        img.style.width = x + "px";
        slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
      }
    }
  }
  initComparisons();

  $(window).resize(function () {
    $(".block__research-results-after-img").css("width", "calc(100% - 50%)");
    $(".block__research-results-img-button").css("left", "calc(48% - 19px)");
  });
}


// Collection/all redire to /collections/all-skincare
var currentUrl = window.location.href;
var currentUrlPath = currentUrl.split('.com')[1];
var currentUrl1 = '/collections/all'
if (currentUrlPath === currentUrl1) {
  window.location.replace('/collections/all-skincare');
}


// Mocra form validation
function Validate(event) {
  var regex = new RegExp("^[0-9-().+]"),
    key = String.fromCharCode(event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) return event.preventDefault(), !1;
}

function ValidateName(event) {
  var regex = new RegExp("^[a-zA-Z]"),
    key = String.fromCharCode(event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) return event.preventDefault(), !1;
}

//one-time subscribe 


